import { render, staticRenderFns } from "./VDraftCarManagerTable.vue?vue&type=template&id=23427c7e"
import script from "./VDraftCarManagerTable.vue?vue&type=script&lang=js"
export * from "./VDraftCarManagerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports